<template>
	<div class="sf-datatable-wrapper h-100">
		<div class="sf-datatable-container h-100">
			<div class="sf-actions">
				<div class="sf-actions__left">
					<!-- Add -->
					<sf-button
						v-if="isButton_(scrId, 'AD')"
						size="lg"
						icon="square-plus"
						color="default"
						:line="true"
						className="sf-button--black-light"
						:onClick="() => Add()"
						>{{ getMessage_('SWCC000007') }}</sf-button
					>
					<!-- Save -->
					<sf-button
						v-if="isButton_(scrId, 'CU')"
						size="lg"
						color="default"
						icon="file"
						:line="true"
						className="sf-button--black-light"
						:onClick="() => Save()"
						>{{ getMessage_('SWCC000103') }}</sf-button
					>
					<!-- Delete -->
					<sf-button
						v-if="isButton_(scrId, 'CD')"
						size="lg"
						icon="trash"
						color="error"
						:line="true"
						className="sf-button--black-light"
						:onClick="() => Delete()"
						>{{ getMessage_('SWCC000328') }}</sf-button
					>
				</div>
			</div>
			<el-table
				class="table-responsive table-flush sf-datatable el-table--scrollable-y"
				ref="dataTable"
				:data="groupScreenFuncList"
				@selection-change="handleSelectionChange"
				stripe
				border
				height="100%"
			>
				<el-table-column type="selection" minWidth="67" width="90"></el-table-column>
				<el-table-column :label="getMessage_('SWCC000150')" property="scrType" minWidth="150px"> </el-table-column>
				<!-- 코드 -->
				<el-table-column :label="getMessage_('SWCC000151')" property="scrTypeNm" minWidth="150px"> </el-table-column>
				<!-- 코드명 -->
				<el-table-column :label="getMessage_('SWCC000152')" property="commCdDesc1" minWidth="200px"> </el-table-column>
				<!-- 코드내용 -->
				<el-table-column :label="getMessage_('SWCC000427')" property="scrUrl" minWidth="250px"> </el-table-column>
				<!-- URL 패턴 -->
				<el-table-column :label="getMessage_('SWCC000171')" property="chgDt" minWidth="250px"> </el-table-column>
				<!-- 수정일 -->
				<el-table-column :label="getMessage_('SWCC000172')" property="chgId" minWidth="130px"> </el-table-column>
				<!-- 수정자 -->
			</el-table>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/UserGroupControlManagement/store/helpers';
export default {
	props: {
		Add: {
			type: Function
		},
		Save: {
			type: Function
		},
		Delete: {
			type: Function
		},
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			title: '',
			multipleSelection: []
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		getData(param) {
			this.title = param == null ? '' : ' - ' + param;
			this.$sf_toggleLoading(true);
			this.getGroupScreenFuncList_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.messageCd
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		addRow(param) {
			let addRow = {};
			if (param.commCd != null) {
				addRow = {
					tableState: 'I',
					scrType: param.commCd,
					scrTypeNm: param.commCdName,
					commCdDesc1: param.commCdDesc1,
					scrUrl: this.searchParams.scrUrl,
					flag1: param.flag1
				};

				this.$refs.dataTable.data.forEach(row => {
					if (addRow != null && row.scrType == addRow.scrType) addRow = null;
				});

				if (addRow != null) this.$refs.dataTable.data.push(addRow);
				this.$refs.dataTable.toggleRowSelection(addRow);
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		resetTable() {
			let tmpData = this.title;
			this.getData();
			this.title = tmpData;
		},
		save() {
			let saveData = {
				status: 1,
				plantCd: this.searchParams.plantCd,
				screenId: this.searchParams.screenId,
				data: []
			};

			this.multipleSelection.forEach(row => {
				if (row.tableState == 'I') {
					let pushSet = {
						permGrpCd: this.searchParams.groupId,
						functionType: row.scrType,
						urlPattern: row.scrUrl == null ? '' : row.scrUrl,
						flag1: row.flag1,
						regIp: '0:0:0:0',
						chgIp: '0:0:0:0'
					};
					saveData.data.push(pushSet);
				}
			});

			if (saveData.data != undefined && saveData.data.length > 0) {
				this.$sf_toggleLoading(true);
				this.postGroupScreenFuncList_(saveData)
					.then(response => {
						if (response.message != undefined && response.message != null) {
							this.$sf_toast({
								type: response.code === 0 ? 'ok' : 'error',
								message: this.getMessage_(response.messageCd)
							});
						}
						this.resetTable();
					})
					.catch(e => {
						this.$sf_toast({
							type: 'error',
							message: e.message ? e.message : e
						});
						Promise.reject(error);
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			}
		},
		remove() {
			let deleteData = {
				status: 3,
				plantCd: this.searchParams.plantCd,
				screenId: this.searchParams.screenId,
				data: []
			};

			this.multipleSelection.forEach(row => {
				if (row.tableState != 'I') {
					let pushSet = {
						permGrpCd: this.searchParams.groupId,
						functionType: row.scrType,
						regIp: '0:0:0:0',
						chgIp: '0:0:0:0'
					};
					deleteData.data.push(pushSet);
				}
			});

			if (deleteData.data != undefined && deleteData.data.length > 0) {
				this.$sf_toggleLoading(true);
				this.postGroupScreenFuncList_(deleteData)
					.then(response => {
						if (response.message != undefined && response.message != null) {
							this.$sf_toast({
								type: response.code === 0 ? 'ok' : 'error',
								message: this.getMessage_(response.messageCd)
							});
						}
						this.resetTable();
					})
					.catch(e => {
						this.$sf_toast({
							type: 'error',
							message: e.message ? e.message : e
						});
						Promise.reject(error);
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			}
		},
		saveClick() {
			if (this.multipleSelection.length < 1) {
				// title 선택한 정보가 없습니다.\
				// message 저장 할 데이터를 선택해 주세요.
				this.$sf_showMessage({ title: this.getMessage_('SWCC000417'), message: this.getMessage_('SWCC000434') });
				return;
			}

			this.$sf_showMessage({
				icon: 'confirm',
				type: 'confirm',
				message: this.getMessage_('SWCC000501'),
				buttons: [{ title: 'Ok', clickFn: this.save }]
			});
		},
		deleteClick() {
			if (this.multipleSelection.length < 1) {
				// title 선택한 정보가 없습니다.\
				// message 삭제 할 데이터를 선택해 주세요.
				this.$sf_showMessage({ title: this.getMessage_('SWCC000417'), message: this.getMessage_('SWCC000418') });
				return;
			}

			this.$sf_showMessage({
				icon: 'confirm',
				type: 'confirm',
				message: this.getMessage_('SWCC000108'),
				buttons: [{ title: 'Ok', clickFn: this.remove }]
			});
		}
	}
};
</script>

<style></style>
